import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CursoService } from '../services/curso-service.service';
import { SpinnerService } from '../services/spinner.service';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-formulario-inscripcion',
  templateUrl: './formulario-inscripcion.component.html',
  styleUrls: ['./formulario-inscripcion.component.css']
})
export class FormularioInscripcionComponent implements OnInit {
  formularioInscripcion: FormGroup = new FormGroup({});

  nacionalidadActiva: string = 'Chilena';
  sexoActivo: string = 'Masculino';
  cursos: any[] = [];
  cursosFiltrados: any[] = [];
  terminoBusqueda: string = '';
  cursoSeleccionado: any = null;
  cursoPreseleccionado: boolean = false;

  constructor(
    private cursoService: CursoService,
    private titleService: Title,
    private spinnerService: SpinnerService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.titleService.setTitle('Cursos - MEDS');
    this.spinnerService.show();
    this.formularioInscripcion = new FormGroup({
      rut: new FormControl(null, [Validators.required, this.validadorRUT]),
      nombres: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(50)]),
      apellidos: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(50)]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      telefono: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]{9}$')]),
      direccion: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      fechaNacimiento: new FormControl(null, Validators.required),
      ciudad: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
      pais: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
      profesion: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
      institucion: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      lugarTrabajo: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      nacionalidad: new FormControl(this.nacionalidadActiva),
      sexo: new FormControl(this.sexoActivo),
      terminos: new FormControl(false, Validators.requiredTrue)
    });

    this.cursoService.obtenerCursos().subscribe(
      data => {
        this.spinnerService.hide();
        // console.log("Data original recibida:", data);
        // console.log("Total de cursos recibidos:", data.length);
        
        // Filtrar cursos con datos completos y vigentes
        this.cursos = data.filter((curso: any) => this.esCursoValido(curso));
        this.cursosFiltrados = [...this.cursos];

        // Preseleccionar curso si viene ?curso=codigo en la URL
        const codigoParam = this.route.snapshot.queryParamMap.get('curso');
        if (codigoParam && /^[a-zA-Z0-9\-]+$/.test(codigoParam)) {
          const match = this.cursos.find(c =>
            c.codigo_curso?.toLowerCase() === codigoParam.toLowerCase()
          );
          if (match) {
            this.cursoSeleccionado = match;
            this.cursoPreseleccionado = true;
            // Mostrar únicamente el curso preseleccionado en el listado
            this.cursosFiltrados = [match];
          }
        }
        
        // console.log("Cursos filtrados y vigentes:", this.cursos);
        // console.log("Total de cursos válidos:", this.cursos.length);
        
        // Mostrar información de cursos rechazados para debug
        const cursosRechazados = data.filter((curso: any) => !this.esCursoValido(curso));
        // console.log("Cursos rechazados (datos incompletos o vencidos):", cursosRechazados.length);
        // console.log("Ejemplos de cursos rechazados:", cursosRechazados.slice(0, 3));
      },
      error => {
        this.spinnerService.hide();
        console.error('Error al obtener cursos:', error);
      }
    );
  }

  convertirFechaFormato(fecha: string): string {
    const fechaObj = new Date(fecha);
    const dia = ('0' + fechaObj.getDate()).slice(-2);
    const mes = ('0' + (fechaObj.getMonth() + 1)).slice(-2);
    const anio = fechaObj.getFullYear();
    return `${dia}-${mes}-${anio}`;
  }

  formatearValorCurso(valor: number | null): string {
    if (valor === null || valor === undefined) {
      return 'Sin valor definido';
    }
    return '$' + valor.toLocaleString('es-CL');
  }

  esCursoValido(curso: any): boolean {
    // Verificar que el curso tenga todos los datos requeridos
    const tieneDatosCompletos = 
      curso.nombre_curso && 
      curso.nombre_curso.trim() !== '' &&
      curso.codigo_curso &&
      curso.codigo_curso.trim() !== '' &&
      curso.fecha_inicio_vigencia &&
      curso.fecha_fin_vigencia &&
      curso.descripcion_curso &&
      curso.id_curso;

    if (!tieneDatosCompletos) {
      return false;
    }

    // Verificar que el curso esté vigente
    return this.esCursoVigente(curso.fecha_inicio_vigencia, curso.fecha_fin_vigencia);
  }

  esCursoVigente(fechaInicio: string, fechaFin: string): boolean {
    const hoy = new Date();
    const inicio = new Date(fechaInicio);
    const fin = new Date(fechaFin);
    
    // Normalizar las fechas para evitar problemas con las horas
    hoy.setHours(0, 0, 0, 0);
    inicio.setHours(0, 0, 0, 0);
    fin.setHours(0, 0, 0, 0);
    
    // El curso está vigente si la fecha actual está entre la fecha de inicio y fin
    return hoy >= inicio && hoy <= fin;
  }

  filtrarCursos(): void {
    if (!this.terminoBusqueda || this.terminoBusqueda.trim() === '') {
      // Si no hay término de búsqueda, mostrar todos los cursos
      this.cursosFiltrados = [...this.cursos];
    } else {
      // Normalizar el término de búsqueda (quitar acentos y convertir a minúsculas)
      const termino = this.normalizarTexto(this.terminoBusqueda.trim());
      this.cursosFiltrados = this.cursos.filter(curso => {
        const nombreCurso = this.normalizarTexto(curso.nombre_curso);
        // Permitir búsquedas por palabras individuales
        const palabrasTermino = termino.split(' ').filter(palabra => palabra.length > 0);
        return palabrasTermino.some(palabra => nombreCurso.includes(palabra));
      });
    }
  }

  private normalizarTexto(texto: string): string {
    return texto
      .toLowerCase()
      .normalize('NFD') // Descompone los caracteres acentuados
      .replace(/[\u0300-\u036f]/g, ''); // Elimina los acentos
  }
  
  onContinuar() {
    if (!this.formularioInscripcion.valid) {
      this.formularioInscripcion.markAllAsTouched(); 
      return;
    }
  
    // Verifica si se ha seleccionado un curso
    if (!this.cursoSeleccionado) {
      alert("Por favor, seleccione un curso.");
      return;
    }
  
    // Verifica si se han aceptado los términos y condiciones
    if (!this.formularioInscripcion.get('terminos')?.value) {
      alert("Debe aceptar los términos y condiciones para continuar.");
      return;
    }

    // Procesa los datos
    const datosContacto = this.formularioInscripcion.value;
    const montoTotal = this.cursoSeleccionado.valor_curso;
  
    // console.log('Datos de Contacto:', datosContacto);
    // console.log('RUT que se enviará al backend:', datosContacto.rut);
    // console.log('Curso Seleccionado:', this.cursoSeleccionado);
    // console.log('Monto Total:', montoTotal);
  
    this.spinnerService.show();
    this.cursoService.enviarSolicitudPago({
      ...datosContacto,
      cursos: [this.cursoSeleccionado.id_curso],
      monto: montoTotal
    }).subscribe(
      (response: any) => {
        // console.log("Respuesta de la pasarela:", response);
  
        if (response.payment_url && response.token) {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = response.payment_url; 
  
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = 'token_ws'; 
          hiddenField.value = response.token; 
          form.appendChild(hiddenField);
  
          document.body.appendChild(form);
  
          form.submit();
        } else {
          this.spinnerService.hide();
          alert("Error al generar el link de pago. Inténtelo nuevamente.");
          console.error("Respuesta incompleta de la pasarela:", response);
        }
      },
      (error: any) => {
        this.spinnerService.hide();
        console.error("Error al enviar la solicitud de pago:", error);
        alert("Hubo un error al procesar el pago. Por favor, inténtelo más tarde.");
      }
    );
  }
  
  onCursoSeleccionado(event: any, curso: any): void {
    // Con radio buttons, siempre se selecciona el curso cuando se hace clic
    this.cursoSeleccionado = curso;
    // console.log("Curso seleccionado:", this.cursoSeleccionado);
  }

  // Quita la preselección por URL y vuelve a mostrar todos los cursos vigentes
  verTodosLosCursos(): void {
    this.cursoPreseleccionado = false;
    this.terminoBusqueda = '';
    this.cursosFiltrados = [...this.cursos];
  }

  setNacionalidad(nacionalidad: string) {
    this.formularioInscripcion.get('nacionalidad')!.setValue(nacionalidad);
    this.nacionalidadActiva = nacionalidad;
  }
  
  setSexo(sexo: string) {
    this.formularioInscripcion.get('sexo')!.setValue(sexo);
    this.sexoActivo = sexo;
  }

  validadorRUT(control: FormControl): {[key: string]: any} | null {
    const rut = control.value;
    if (!rut) return null;

    // Limpiar el RUT (quitar puntos, guiones y espacios para validación)
    const rutLimpio = rut.toString().replace(/[^0-9kK]/g, '');
    
    // Verificar que tenga entre 8 and 9 caracteres
    if (rutLimpio.length < 8 || rutLimpio.length > 9) {
      return { 'rutInvalido': true };
    }

    // Separar el cuerpo del dígito verificador
    const cuerpo = rutLimpio.slice(0, -1);
    const digitoVerificador = rutLimpio.slice(-1).toLowerCase();

    // Calcular el dígito verificador
    let suma = 0;
    let multiplicador = 2;

    for (let i = cuerpo.length - 1; i >= 0; i--) {
      suma += parseInt(cuerpo[i]) * multiplicador;
      multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
    }

    const resto = suma % 11;
    const digitoCalculado = resto === 0 ? '0' : resto === 1 ? 'k' : (11 - resto).toString();

    const isValidRUT = digitoVerificador === digitoCalculado;
    return isValidRUT ? null : { 'rutInvalido': true };
  }

  // Método para formatear el RUT automáticamente
  formatearRUT(event: any): void {
    const input = event.target;
    let valor = input.value;

    // Remover todo excepto números y K/k
    valor = valor.replace(/[^0-9kK]/g, '');

    // Si está vacío, no hacer nada
    if (!valor) {
      input.value = '';
      this.formularioInscripcion.get('rut')?.setValue('');
      return;
    }

    // Convertir a mayúscula solo la K
    valor = valor.replace(/k/g, 'K');

    // Formatear si tiene al menos 2 caracteres
    if (valor.length >= 2) {
      // Separar cuerpo y dígito verificador
      const cuerpo = valor.slice(0, -1);
      const dv = valor.slice(-1);
      
      // Resultado final SIN puntos, solo con guión
      const rutFormateado = `${cuerpo}-${dv}`;
      input.value = rutFormateado;
      
      // Actualizar el FormControl con el valor formateado (sin puntos) para el backend
      this.formularioInscripcion.get('rut')?.setValue(rutFormateado);
    } else {
      input.value = valor;
      this.formularioInscripcion.get('rut')?.setValue(valor);
    }
  }
}
